"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEAT_CENTER_ICON = exports.FLATBED_STATUS = exports.FLATBED_LABEL = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FLATBED_LABEL;

var FLATBED_STATUS = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
  SELECTED: 'SELECTED'
};
exports.FLATBED_STATUS = FLATBED_STATUS;
var FLATBED_LABEL = (_FLATBED_LABEL = {}, (0, _defineProperty2.default)(_FLATBED_LABEL, FLATBED_STATUS.AVAILABLE, 'Flatbed / Available'), (0, _defineProperty2.default)(_FLATBED_LABEL, FLATBED_STATUS.UNAVAILABLE, 'Flatbed / Unavailable'), (0, _defineProperty2.default)(_FLATBED_LABEL, FLATBED_STATUS.SELECTED, 'Flatbed / Selected'), _FLATBED_LABEL);
exports.FLATBED_LABEL = FLATBED_LABEL;
var SEAT_CENTER_ICON = {
  STAR_ICON: 'STAR_ICON',
  VOLUME_OFF_ICON: 'VOLUME_OFF_ICON'
};
exports.SEAT_CENTER_ICON = SEAT_CENTER_ICON;